<template>
  <div>
		<section class="about" id="about">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-5 p-0">
                        <img src="../../static/images/about1.jpg" alt="" class="img-fluid" />
                    </div>
                    <div class="col-lg-6">
                        <div class="about-right">
                            <h4 class="main">Artur Walemo, Programming Solutions Tecniques.</h4>
                            <p>Formado na Àrea das TIC's Ramo de Programação, Com finalidade de contribuir parao mundo digital. </p>
                            <div class="row mt-sm-5 mt-4 about-right-inner">
                                <div class="col-sm-4 col-6 myphoto-sign text-center">
                                    <img src="../../static/images/menPort.jpg" alt="" style="border-radius: 50%" class="img-fluid mt-3"/>
                                    <img src="../../static/images/signature.png" alt="" class="img-fluid mt-3"/>
                                    <a href="#contact" class="scroll abt-btn">Contrate-me </a>
                                </div>
                                <div class="col-sm-7 offset-lg-1">
                                    <!-- <h4>Informação pessoal</h4>
                                    <p>Hello, My name is <strong>John Watson</strong>. I am 6 years experienced <strong>web designer</strong></p> -->
                                    <h4 class="mt-4">Skills & Abilidades</h4>
                                    <div class="progress-one mt-3">
                                        <h4 class="progress-tittle">Web Designing</h4>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="progress-one mt-3">
                                        <h4 class="progress-tittle">Web Developmenet</h4>
                                        <div class="progress">
                                            <div class="progress-bar bg-danger" role="progressbar" style="width: 90%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="progress-one mt-3">
                                        <h4 class="progress-tittle">Php</h4>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: 80%; background: #ffde57;" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="progress-one mt-3">
                                        <h4 class="progress-tittle">Laravel</h4>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: 85%; background: #092e20;" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="progress-one">
                                        <h4 class="progress-tittle">App Development</h4>
                                        <div class="progress">
                                            <div class="progress-bar bg-info" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3 class="position">Sobre Me</h3>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/About.vue